import { Component, OnInit, OnDestroy } from '@angular/core';
import messages from '../assets/data/devextreme/locale.json';
import { locale, loadMessages } from 'devextreme/localization';

import { BaseService } from '../app/core/services/base.service';
import { NotificationService } from './core/services/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Koora Stars';

  loadingScreen: boolean = true;
  progress = 0;

  private intervalId: any;

  constructor(
    private baseService: BaseService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.startFakeLoading();

    loadMessages(messages);
    locale(localStorage.getItem('lang') || 'ar');

    this.handleSessionAndSignalR();
  }

  private handleSessionAndSignalR(): void {
    const expirationTime = localStorage.getItem('expirationTime');

    if (!expirationTime) {
      this.startNotifications();
      return;
    }

    const timeLeft = Number(expirationTime) - new Date().getTime();

    if (timeLeft > 0) {
      this.baseService.setLogoutTimer(timeLeft / 1000);
      this.startNotifications();
    } else {
      this.baseService.autoLogout();
    }
  }

  private startNotifications(): void {
    const token =
      localStorage.getItem('accessToken') ||
      localStorage.getItem('token');

    if (!token) {
      console.warn('SignalR not started: no access token found');
      return;
    }

    if (this.notificationService.isConnected()) {
      console.log('SignalR already connected');
      return;
    }

    this.notificationService
      .startConnection()
      .then(() => {
        console.log('Notification SignalR connected');
      })
      .catch(error => {
        console.error('Notification SignalR connection error:', error);
      });
  }

  startFakeLoading(): void {
    this.intervalId = setInterval(() => {
      if (this.progress >= 100) {
        clearInterval(this.intervalId);

        setTimeout(() => {
          this.loadingScreen = false;
        }, 10);

        return;
      }

      let increment = 0;

      if (this.progress < 30) {
        increment = Math.random() * 4 + 2;
      } else if (this.progress < 70) {
        increment = Math.random() * 1 + 0.5;
      } else {
        increment = Math.random() * 3 + 2;
      }

      this.progress = Math.min(100, this.progress + increment);
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.notificationService.stopConnection();
  }
}